
import { computed, defineComponent } from "vue";
import { useStore } from "../../store";
import { TypeNotification } from "@/enums/TypeNotification";
import useNotificador from "../../hooks/notificador";
import { GET_PROJECTS, REMOVE_PROJECT } from "@/store/type-actions";

export default defineComponent({
  name: "Projetos",
  methods: {
    excluir(id: string) {
      this.store.dispatch(REMOVE_PROJECT, id);
      this.notificar(
        TypeNotification.SUCESSO,
        "Excelente !",
        "Projeto Excluido com Sucesso"
      );
    },
  },

  setup() {
    const store = useStore();
    const { notificar } = useNotificador();
    store.dispatch(GET_PROJECTS);

    return {
      projetos: computed(() => store.state.project.projetos),
      store,
      notificar,
    };
  },
});
